import { Action } from "./Action";
import { IActionWithData, IDataForAction } from "./IAction";

export class ActionWithData extends Action implements IActionWithData {
    public data: IDataForAction;
}
